import { render } from "./GroupPage.vue?vue&type=template&id=46ca2a27"
import script from "./GroupPage.vue?vue&type=script&lang=js"
export * from "./GroupPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__